import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProgresshillComponent } from '../progresshill/progresshill.component';

@Component({
    selector: 'app-timetrackerpopup',
    templateUrl: './timetrackerpopup.component.html',
    styleUrls: ['./timetrackerpopup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ProgresshillComponent],
})
export class TimetrackerpopupComponent {
  @Input() organizationKey: string = ""
  @Input() projectKey: string = ""
  @Input() workpackageKey: string = ""
  @Input() userId: string = ""
  @Input() userName: string = ""
  @Input() circleColor = "red"
  @Input() projectName: string = ""
  @Input() workpackageName: string = ""
  @Input() startDate: string = ""
  @Input() endDate: string = ""
  @Output() progressHillClosed = new EventEmitter<{startDate: string, endDate: string, reportedHours: number, progressPercent: number}>()
  pathData: string;
  progressPoints: { x: number, y: number, progress: number, label: string, color: string}[] = [];
  circleRadius = 7
  draggingPoint: any = null;
  pickedDate: string = ""
  totalReportedHours = 0
  reportedHours = 0
  taskNotes = ""
  progressDataIsLoaded = false
  showProgressHill = false
  strippedWorkpackageName = ""

  @ViewChild('bellCurve', { static: true }) bellCurve: ElementRef<SVGSVGElement>;

  constructor(private firestore: FirestoreService) { 
    this.pickedDate = new Date().toISOString().split('T')[0];
  }

  ngOnInit() {
    setTimeout(() => {
      this.initProgressHill()
    }, 1000)
  }

  ngOnDestroy() {
    this.progressHillClosed.emit({startDate: this.startDate, endDate: this.endDate, reportedHours: this.reportedHours, progressPercent: this.progressPoints[0].progress})
  }

  async initProgressHill() {
    if (this.workpackageName.length > 40) {
      this.strippedWorkpackageName = this.firestore.stripHTML(this.workpackageName.slice(0, 40) + "...")
    } else {
      this.strippedWorkpackageName = this.firestore.stripHTML(this.workpackageName)
    }
    await this.firestore.getProgressPercentByWorkpackage(this.organizationKey, this.workpackageKey).then(snap => {
      let progressPercent = snap || 0
      this.progressPoints.push({x: 0, y: 0, progress: progressPercent, label: this.strippedWorkpackageName, color: this.circleColor });
      this.progressDataIsLoaded = true
    })
    await this.getReportedHours()
    this.showProgressHill = true
  }

  async getReportedHours() {
    await this.firestore.getPost(this.organizationKey, this.workpackageKey).then(snap => {
      this.totalReportedHours = snap.get("reportedHours")
      if (this.totalReportedHours == undefined) {
        this.totalReportedHours = 0
      }
    })
  }

  saveTime() {
    if (this.startDate == undefined ) {
      this.startDate = ""
    }
    if (this.endDate == undefined ) {
      this.endDate = ""
    }
      this.firestore.saveTimeTrack(this.organizationKey, this.projectKey, this.workpackageKey, this.userId, this.pickedDate, this.reportedHours, this.taskNotes, this.progressPoints[0].progress, this.startDate, this.endDate).then(() => {
        this.firestore.showSnackBar("Time tracking report was saved.")
        this.close()
      })
  }


  close() {
    this.progressHillClosed.emit({startDate: this.startDate, endDate: this.endDate, reportedHours: this.reportedHours, progressPercent: this.progressPoints[0].progress})
  }

  onProgressHillUpdated(points: { x: number, y: number, progress: number, label: string, color: string }[]) {
    this.progressPoints = points
  }

  onStartDateChange(date: string) {
    this.startDate = date
    if (this.endDate != undefined && this.checkIfStartDateIsBeforeEndDate() == false) {
      this.firestore.showSnackBar("Start date cannot be after end date.")
      this.startDate = this.endDate
    } 
  }

  onEndDateChange(date: string) {
    this.endDate = date
    if (this.startDate != undefined && this.checkIfStartDateIsBeforeEndDate() == false) {
      this.firestore.showSnackBar("End date cannot be before start date.")
      this.endDate = this.startDate
    } 
  }

  checkIfStartDateIsBeforeEndDate() {
    const start = new Date(this.startDate)
    const end = new Date(this.endDate)
    return start <= end
  }
}
